/** Minimum action-column widths when horizontal scroll is active. */
export const TABLE_ACTION_MIN_WIDTH = {
  searches: 420,
  subscriptions: 440,
  recipients: 480,
  team: 320,
  sources: 280,
  jobs: 240,
  knownChats: 220,
} as const;

export type TableActionPreset = keyof typeof TABLE_ACTION_MIN_WIDTH;

export function tableActionsColumnClass(preset: TableActionPreset): string {
  return `table-actions-cell table-actions-cell--${preset}`;
}
